const IkeaFamilyForwarIcon = () => {
  return (
    <svg
      className="JoinIkeaFamilyForwardIcon"
      id="IFForwardIcon"
      style={{ width: "36px", height: "36px" }}
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <path
        d="M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></path>
      <line
        x1="200"
        y1="40"
        x2="200"
        y2="216"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
    </svg>
  );
};
export default IkeaFamilyForwarIcon;
